/**
 * Bloc anecdote : classe portrait / paysage selon les dimensions réelles
 * de la photo (sans recadrage — le cadre s'adapte à l'image).
 */
(function () {
  if (window.__dasiAnecdoteImg) return;
  window.__dasiAnecdoteImg = true;

  function orient(img) {
    const wrap = img.closest('.anecdote-section__visual');
    if (!wrap) return;
    const w = img.naturalWidth;
    const h = img.naturalHeight;
    if (!w || !h) return;
    wrap.classList.remove(
      'anecdote-section__visual--portrait',
      'anecdote-section__visual--landscape',
    );
    wrap.classList.add(
      w >= h
        ? 'anecdote-section__visual--landscape'
        : 'anecdote-section__visual--portrait',
    );
  }

  function init() {
    document.querySelectorAll('.anecdote-section__img').forEach((img) => {
      if (img.complete && img.naturalWidth) orient(img);
      else img.addEventListener('load', () => orient(img), { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();